import { Injectable } from '@angular/core';
import { Sepa } from '../../dto/sepa';
import { CrudService } from '../../services';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {toISODateString, toServerDateString} from '../../providers/app-date-adapter';
import { EnumModel } from '../../models/enum-model';
import { DataListModel } from '../../models/data-list-model';
import {RevolutTransactionLeg} from '../../dto/revolut-transaction-leg';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {PrevNextModel} from '../../models/prev-next-model';
import {InvoiceSearch} from '../../dto/invoice-search';
import {CulpaStatsModel} from '../../models/culpa-stats-model';

@Injectable( {
  providedIn: 'root'
} )

export class RevolutService implements CrudService<RevolutTransactionLeg> {
  readonly apiPath = 'revolut/';

  constructor( private http: HttpClient ) { }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
  ): Observable<DataListModel<RevolutTransactionLeg>> {
    const params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection )
      .set('someAdditionalData', someAdditionalData);
    return this.http.get( this.apiPath, { params } ) as Observable<DataListModel<RevolutTransactionLeg>>;
  }

  get( id: number ): Observable<RevolutTransactionLeg> {
    return this.http.get( this.apiPath + id ) as Observable<RevolutTransactionLeg>;
  }

  add( item: RevolutTransactionLeg ): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }
  update( item: RevolutTransactionLeg ) {
    return this.http.put( this.apiPath, item ) as Observable<RevolutTransactionLeg>;
  }

  delete( id: any ) {
    return this.deleteMany( [ id ] );
  }

  restore( id: any ) {
    return this.restoreMany( [ id ] );
  }



  deleteMany( idList: any[] ) {
    let httpParams = new HttpParams();

    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );

    return this.http.delete( this.apiPath, { params: httpParams } );
  }

  restoreMany( idList: any[] ) {
    let httpParams = new HttpParams();
    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );
    return this.http.patch( this.apiPath, null, { params: httpParams } );
  }


  getPrev(filters: DateTableFilter, invoiceId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/prev`, { params }) as Observable<number>;
  }

  getNext(filters: DateTableFilter, invoiceId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/next`, { params }) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, invoiceId: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/prev-next`, { params }) as Observable<PrevNextModel>;
  }

  searchInvoices(term: string): Observable<InvoiceSearch[]> {

    let params = new HttpParams();

    if( term != null ) {
      params = params.set('term', term);
    }

    return this.http.get(`${this.apiPath}search-invoices`, { params }) as Observable<InvoiceSearch[]>;
  }

  getFilterParams(filters: DateTableFilter): HttpParams {
    const str =  filters != null ? filters.str || '' : '';
    const dateFilterCols = filters != null ? filters.dateFilterCols || [] : [];
    const startFilterDate = filters != null ? filters.startFilterDate || null : null;
    const endFilterDate = filters != null ? filters.endFilterDate || null : null;
    const someAdditionalData = filters != null ? filters.someAdditionalData || null : null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (filters != null && filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters != null && filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }



    return params;
  }

  linkTransactionToInvoice(revolutTransactionLegId: number, invoiceId: number, nr: number){

    // this is only here to keep the url. the backend will determine forcePaid
    const forcePaid = false;

    return this.http.patch(this.apiPath + 'link-trans-inv/' + revolutTransactionLegId + '/' + invoiceId + '/' + nr + '/' + forcePaid, null);

  }

  unlinkTransactionToInvoice(revolutTransactionLegId: number, invoiceId: number, nr: number){

    return this.http.delete(this.apiPath + 'unlink-trans-inv/' + revolutTransactionLegId + '/' + invoiceId + '/' + nr);

  }

  getCulpaStats(){
    return this.http.get(`${this.apiPath}culpa-stats`, { }) as Observable<CulpaStatsModel>;
  }




}
